import { Inline, Text } from '@etg/wings';
import type { CheckedBaggageSummary } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { XCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import isCheckedBaggageNotIncluded from './utils/isCheckedBaggageNotIncluded';
import { iconStyles } from './CabinBaggageFeature';

const featureTextStyles = css`
  color: #737373;
  width: -webkit-fill-available; /* stylelint-disable */
`;

interface CheckedBaggageNotIncludedFeatureProps {
  checkedBaggageSummary: CheckedBaggageSummary;
}

const CheckedBaggageNotIncludedFeature = ({
  checkedBaggageSummary,
}: CheckedBaggageNotIncludedFeatureProps) => {
  const { t } = useTranslation();
  if (!isCheckedBaggageNotIncluded(checkedBaggageSummary)) {
    return null;
  }
  const checkedInBaggageName = t('BrandedFares.CheckInBaggageNotIncluded.Text', 1);
  return (
    <Inline as="li" noWrap role="listitem" spacing={8}>
      <XCircle className={iconStyles} color="#737373" size={20} weight="thin" />
      <Text as="p" className={featureTextStyles}>
        {checkedInBaggageName}
      </Text>
    </Inline>
  );
};

export default CheckedBaggageNotIncludedFeature;
